import React, { useState, useEffect } from "react";
import { lighten, makeStyles, useTheme } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import { connect } from "react-redux";

import SvgIcon from "@material-ui/core/SvgIcon";
import KpsListItem from "../../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import ItemContentRevision from "../../list-item/ItemContentRevision";
import moment from "moment";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import DisplayUser from "../../user/DisplayUser";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import FlagIcon from "@material-ui/icons/Flag";
import { Badge } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { withTranslation, useTranslation } from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import BlockIcon from "@material-ui/icons/Block";
import Tooltip from "@material-ui/core/Tooltip";

import { taxServiceClient, contentClient } from "../../../AxiosClient";
import {
  currentUserHasRole,
  Role,
  currentUserIsOperator,
} from "../../../utils/RoleUtils";

const useStyles = makeStyles((theme) => ({
  timelineRoot: {
    width: "100%",
  },
  liveRevisionTimeline: {
    backgroundColor: theme.palette.success.main,
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  awaitingReviewTimeline: {
    backgroundColor: theme.palette.warning.main,
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  awaitingApprovalTimeline: {
    backgroundColor: theme.palette.warning.main,
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  awaitingPublishTimeline: {
    backgroundColor: theme.palette.warning.main,
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  draftTimeline: {
    backgroundColor: theme.palette.info.main,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  beingEditedTimeline: {
    backgroundColor: theme.palette.grey[400],
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  addRevisionTimeLine: {
    backgroundColor: theme.palette.secondary.main,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  emptyTimeline: {
    backgroundColor: theme.palette.grey[300],
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  timelineSeparator: {
    minHeight: "90px",
  },
  addRevisionLabel: {
    whiteSpace: "nowrap",
  },
  addRevisionButton: {
    marginBottom: theme.spacing(2),
  },
  startTimeline: {
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(2),
  },
  timeLineContent: {
    marginTop: "-6px",
  },
  liveWrapper: {
    //   width: "80%",
    //   textAlign : "center",
    backgroundColor: lighten(theme.palette.success.light, 0.85),
    //   marginLeft: theme.spacing(3),
    //   marginRight: theme.spacing(3),
  },
  typographyDisabled: {
    marginTop: theme.spacing(1.5),
    color: theme.palette.text.disabled,
    fontWeight: "normal",
  },
  typographyDisabledNoMargin: {
    color: theme.palette.text.disabled,
    fontWeight: "normal",
  },
  workflowWarning: {
    display: 'inline-flex',
    alignItems: "flex-end",
    // marginTop: "auto",
    // marginBottom: "auto",
  },
  workflowWarningTitle: {
    marginLeft: theme.spacing(1),
  },
  tooltipMarginTop: {
    marginTop: theme.spacing(1),
  },
  tooltipMarginBottom: {
    marginBottom: theme.spacing(1),
  },
}));

function RevisionSummaryTimeline(props) {
  const AWAITING_PUBLISH = "AWAITING_PUBLISH";
  const AWAITING_REVIEW = "AWAITING_REVIEW";
  const AWAITING_APPROVAL = "AWAITING_APPROVAL";
  const REVIEWED_AWAITING_APPROVAL_STAGE = "REVIEWED_AWAITING_APPROVAL_STAGE";
  const DRAFT = "DRAFT";

  const inProgress =
    "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z";
  const beExpert =
    "M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z";
  const reviewer =
    "M20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H8L12,22L16,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,4.3C13.5,4.3 14.7,5.5 14.7,7C14.7,8.5 13.5,9.7 12,9.7C10.5,9.7 9.3,8.5 9.3,7C9.3,5.5 10.5,4.3 12,4.3M18,15H6V14.1C6,12.1 10,11 12,11C14,11 18,12.1 18,14.1V15Z";
  const approver =
    "M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z";
  const published =
    "M17,21L14.25,18L15.41,16.84L17,18.43L20.59,14.84L21.75,16.25M12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21M12,15H7V17H12M17,7H7V9H17";
  const waiting =
    "M6,2H18V8H18V8L14,12L18,16V16H18V22H6V16H6V16L10,12L6,8V8H6V2M16,16.5L12,12.5L8,16.5V20H16V16.5M12,11.5L16,7.5V4H8V7.5L12,11.5M10,6H14V6.75L12,8.75L10,6.75V6Z";
  const draft =
    "M8,12H16V14H8V12M10,20H6V4H13V9H18V12.1L20,10.1V8L14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H10V20M8,18H12.1L13,17.1V16H8V18M20.2,13C20.3,13 20.5,13.1 20.6,13.2L21.9,14.5C22.1,14.7 22.1,15.1 21.9,15.3L20.9,16.3L18.8,14.2L19.8,13.2C19.9,13.1 20,13 20.2,13M20.2,16.9L14.1,23H12V20.9L18.1,14.8L20.2,16.9Z";
  const editInProgress =
    "M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z";
  //"M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
  const addItem = "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z";
  const defaultWorkflowUsers = {reviewers: 0, approvers: 0, publishers: 0}

  // const [revisions] = useState(props.revisions);
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const [revisionSummary, setRevisionSummary] = useState();
  const [workflowActive, setWorkflowActive] = useState(false)
  const [workflowUsers, setWorkflowUsers] = useState(defaultWorkflowUsers)
  const [workflowTeams, setWorkflowTeams] = useState([])
  const [reviewInTaxWorkflow, setReviewInTaxWorkflow] = useState(false)
  const [approveInTaxWorkflow, setApproveInTaxWorkflow] = useState(false)
  const [publishInTaxWorkflow, setPublishInTaxWorkflow] = useState(false)
  const [reviewerTeams, setReviewerTeams] = useState(0)
  const [approverTeams, setApproverTeams] = useState(0)
  const [publisherTeams, setPublisherTeams] = useState(0)

  useEffect(
    () => {
      setWorkflowActive(isWorkflowActive())
    },
    [props.knowledgeItem]
  )
  useEffect(
    () => {
      if (workflowActive === true) {
        findWorkflowTeams()
      }
    },[workflowActive]
  )
  useEffect(
    () => {
      if (workflowActive === true) {
        taxServiceClient
        .get(`/topic/${props.knowledgeItem.topic.topicId}/workflowsummary/${props.knowledgeItem.knowledgeSource.classification}/`)
        .then((res) => {
          if (res.data) {
            setWorkflowUsers(res.data)
          }
        });
      } else {
        setWorkflowUsers(defaultWorkflowUsers)
      }
    },
    [workflowActive]
  )
  useEffect( 
    () => {
      contentClient
      .get(`/knowledgeitem/${props.knowledgeItem.itemId}/revision/summary`)
      .then((res) => {
        if (res.data) {
          setRevisionSummary(res.data)
          props.onLoaded && 
            props.onLoaded(res.data)
          // setTimeline(getTimeline(res.data))
        }
      });
    }, 
    []
  ) 

  const getTimelineItem = (className, icon, content, opposite) => {
    return (
      <TimelineItem>
        {opposite && (
          <TimelineOppositeContent>{opposite}</TimelineOppositeContent>
        )}
        <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
          <TimelineDot classes={{ root: className }}>
            <SvgIcon>
              <path d={icon} />
            </SvgIcon>
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent classes={{ root: classes.timeLineContent }}>
          {content}
        </TimelineContent>
      </TimelineItem>
    );
  };
  const getDisabledWorkflowTooltip = (action, role, numTeams, workflowStageActive) => {
    return (
      <>
      {action === "publish" 
        ?
          <>
            <Typography variant="h6" classes={{ h6: classes.tooltipMarginBottom }}>
              <b>
                {
                  t("workflow_disabled_stage_no_publishers")
                }
              </b>
            </Typography>
            <Typography variant="body1" classes={{ body1: classes.tooltipMarginBottom }}>
              {
                t("workflow_disabled_stage_tooltip_start",{team: numTeams > 1 ? t("global_team_plural") : t("global_team")}) 
              }
            </Typography>

            <Typography variant="body1">
            <b>{`${workflowTeams.filter(w => w.object[role.toLowerCase()] === true).map(t => t.name).join()}`}</b>
            </Typography>
            <Typography variant="body1" classes={{ body1: classes.tooltipMarginTop }}>
              {
                t("workflow_disabled_stage_tooltip_end",{action: action, role: role, team: numTeams > 1 ? t("global_team_plural") : t("global_team")}) 
              }
            </Typography>
          </>
        :
          <>
            {workflowStageActive === true?
              <>
                <Typography variant="h6" classes={{ h6: classes.tooltipMarginBottom }}>
                  <b>
                    {
                    t("workflow_step_disabled")
                    }
                  </b>
                </Typography>
                <Typography variant="body1" classes={{ body1: classes.tooltipMarginBottom }}>
                  {
                    t("workflow_disabled_stage_tooltip_start",{team: numTeams > 1 ? t("global_team_plural") : t("global_team")})
                  }
                </Typography>

                <Typography variant="body1">
                <b>{`${workflowTeams.filter(w => w.object[role.toLowerCase()] === true).map(t => t.name).join()}`}</b>
                </Typography>
                <Typography variant="body1" classes={{ body1: classes.tooltipMarginTop }}>
                  {
                    t("workflow_disabled_stage_tooltip_end",{action: action, role: role, team: numTeams > 1 ? t("global_team_plural") : t("global_team")})
                  }
                </Typography>
              </>
              :
              <>
                <Typography variant="h6" classes={{ h6: classes.tooltipMarginBottom }}>
                  <b>
                    {
                    t("workflow_step_no_longer_applies")
                    }
                  </b>
                </Typography>
                {
                  t("workflow_state_from_previous_does_not_match_current")
                }
              </>
            }
          </>
      }
      </>
    )
  }
  const isWorkflowActive = () => {
    let workflowActive = false
    let topic = props.taxonomyNodeLookup.filter(t => t.id === props.knowledgeItem.topic.topicId && t.type === "topic")[0]
    if (topic) {
      workflowActive = topic.workflowActive && topic.workflowActive === true ? true : false 
    }
    return workflowActive
  }
  const findWorkflowTeams = () => {
    let topic = props.taxonomyNodeLookup.filter(t => t.id === props.knowledgeItem.topic.topicId && t.type === "topic")[0]
    if (topic) {
      let parents = props.taxonomyNodeLookup.filter(
        t => topic.parentList.includes(t.id) 
        && t.type === "taxonomy" 
      )
      let teams = []
      parents.forEach(p => {
        teams = teams.concat(p.children.filter(c => c.type === "team").filter(c => c.object &&
          c.object.approver === true || c.object.reviewer === true || c.object.publisher === true))
      })
      setWorkflowTeams(teams)
      let reviewerTeams = teams.filter(t => t.object.reviewer === true)
      setReviewerTeams(reviewerTeams.length)
      let hasReviewerTeams = (teams.length > 0 && reviewerTeams.length > 0) ? true : false
      setReviewInTaxWorkflow(hasReviewerTeams)
      let approverTeams = teams.filter(t => t.object.approver === true)
      setApproverTeams(approverTeams.length)
      let hasApproverTeams = teams.length > 0 && approverTeams.length > 0 ? true : false
      setApproveInTaxWorkflow(hasApproverTeams)
      let publisherTeams = teams.filter(t => t.object.publisher === true)
      setPublishInTaxWorkflow(teams.length > 0 && publisherTeams.length > 0 ? true : false)

    }

  }

  if (!revisionSummary) return <></>

  // We take the following into consideration:
  // - Knowledge Source Settings
  // - whether workflow is enabled for the topic (having a team ancestor that has the appropriate role) indicated by 
  // - whether there are any users in the teams that have the correct role to carry out the workflow
  // - whether the user is a System Admin, in which case we will indicate the fact that the step is missed 
  //   (due to there not being users able to carry out the stage)
  const isSysAdmin = currentUserHasRole(Role.SYSTEM_MANAGER) ? true : false
  const workflow = revisionSummary.workflow; //from associated KnowledgeSource
  const reviewerStageEnabled =
    (workflow !== null && 
    workflow.reviewersRequired > 0 && 
    workflowActive === true &&
    reviewInTaxWorkflow === true
      && (isSysAdmin || workflowUsers.reviewers > 0)) 
        ? true 
        : false
  const approvalStageEnabled =
    (workflow !== null && 
      workflow.approversRequired > 0 && 
      workflowActive === true &&
      approveInTaxWorkflow === true
      && (isSysAdmin || workflowUsers.approvers > 0)) 
        ? true 
        : false
  const publishStageEnabled =
    (workflow !== null && 
      // workflow.publishRequired && 
      workflowActive === true &&
      publishInTaxWorkflow === true
      && (isSysAdmin || workflowUsers.publishers > 0)) 
        ? true 
        : false
  const autostartApproval =
    workflow !== null ? workflow.autostartApproval : false;

  // The following reflect the state of any draft revision.  
  // Note that even for revisions with no workflow will have a revision workflowState that is AWAITING_PUBLISH.  
  // You also have to consider the fact that the revision's state may have been set before workflow was added to 
  // the taxonomy so you may have a revision in a state that no longer matches.  For this reason if we have a draft 
  // in any state we still have to display it regardless of whether it matches current workflow on the taxonomy.

  const awaitingPublish =
    revisionSummary.draftRevision &&
      revisionSummary.draftRevision.workflowState === AWAITING_PUBLISH
      ? revisionSummary.draftRevision : null
  const awaitingReview =
    revisionSummary.draftRevision &&
      revisionSummary.draftRevision.workflowState === AWAITING_REVIEW
      ? revisionSummary.draftRevision : null
  const awaitingApprovalStage =
    revisionSummary.draftRevision &&
      revisionSummary.draftRevision.workflowState === REVIEWED_AWAITING_APPROVAL_STAGE
      ? revisionSummary.draftRevision : null
  const awaitingApproval =
    revisionSummary.draftRevision &&
      revisionSummary.draftRevision.workflowState === AWAITING_APPROVAL
      ? revisionSummary.draftRevision : null

  const beingEdited = revisionSummary.latestBeingEdited && revisionSummary.latestBeingEdited.workflowState === null 
    ? revisionSummary.latestBeingEdited
    : null 
  const originalVersion = revisionSummary.originalRevision

  return (
    <>
      {workflow !== null && (
        <Timeline align="left" classes={{ root: classes.timelineRoot }}>
          {
            <TimelineItem>
              <TimelineSeparator
                classes={{ root: classes.timelineSeparator }}
              >
                {/* <TimelineDot classes={{ root: classes.addRevisionTimeLine }}> */}
                {!props.isMobile ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    classes={{
                      label: classes.addRevisionLabel,
                      contained: classes.addRevisionButton,
                    }}
                    onClick={props.addRevision}
                    disabled={props.isMobile}
                  >
                    {props.t("new_revision")}
                  </Button>
                ) : (
                  <Alert severity="info">
                    {props.t("Creating_revision_not available_mobile")}
                  </Alert>
                )}
                {/* </TimelineDot> */}
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent classes={{ root: classes.timeLineContent }}>
                <KpsListItem hideExpand={true} isPortlet={false}>
                  <ListItemText primary={""} secondary={""} />
                </KpsListItem>
              </TimelineContent>
            </TimelineItem>
          }

          {beingEdited && beingEdited !== null &&
            getTimelineItem(
              classes.beingEditedTimeline,
              editInProgress,
              <ItemContentRevision
                timeline
                key={"beingEdited"}
                onItemClick={props.onRevisionClick}
                data={beingEdited}
                onRevisionClick={props.onRevisionClick}
                extendedSettings={JSON.stringify([
                  { label: "settings_content_revision_author", order: 0 },
                  {
                    label: "settings_content_revision_created_date",
                    order: 1,
                  },
                ])}
                secondarySetting={"author"}
              />,
              <>
                <Typography variant="body2" color="textSecondary">
                  {beingEdited.createdDate !== null
                    ? "Last edited " +
                    moment(beingEdited.createdDate).fromNow()
                    : ""}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <b>{props.t("workflow_being_edited")}</b>
                </Typography>
              </>
            )}

          {(reviewerStageEnabled || awaitingReview !== null) &&
            getTimelineItem(
              awaitingReview !== null
                ? classes.awaitingReviewTimeline
                : classes.emptyTimeline,
              reviewer,
              awaitingReview !== null ? (
                <ItemContentRevision
                  timeline
                  key={"awaitingreview"}
                  onItemClick={props.onRevisionClick}
                  data={awaitingReview}
                  onRevisionClick={props.onRevisionClick}
                  extendedSettings={JSON.stringify([
                    { label: "settings_content_revision_author", order: 0 },
                    {
                      label: "settings_content_revision_created_date",
                      order: 1,
                    },
                  ])}
                  secondarySetting={"author"}
                />
              ) : (
                <></>
              ),
              awaitingReview ? (
                <>
                  {workflowUsers.reviewers === 0 && isSysAdmin &&
                    <div>
                      <Tooltip
                        title={getDisabledWorkflowTooltip("review","Reviewer",reviewerTeams, reviewInTaxWorkflow)}
                      >
                        <div className={classes.workflowWarning}>
                          <BlockIcon color="error" />
                          <Typography
                            variant="body2"
                            classes={{ body2: classes.workflowWarningTitle }}
                          >
                            {reviewInTaxWorkflow === true ? t("workflow_step_disabled") : t("workflow_step_no_longer_applies")}
                          </Typography>
                        </div>
                      </Tooltip>
                    </div>
                  }
                  <Typography variant="body2" color="textSecondary">
                    {awaitingReview.createdDate !== null
                      ? moment(awaitingReview.createdDate).fromNow()
                      : ""}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <b>{props.t("workflow_awaiting_review")}</b>
                  </Typography>
                </>
              ) : (
                workflowUsers.reviewers === 0 && isSysAdmin 
                  ? 
                    <div>
                      <Tooltip
                        title={getDisabledWorkflowTooltip("review","Reviewer",reviewerTeams, reviewInTaxWorkflow)}
                      >
                        <div className={classes.workflowWarning}>
                          <BlockIcon color="error" />
                          <Typography
                            variant="body2"
                            classes={{ body2: classes.workflowWarningTitle }}
                          >
                            {reviewInTaxWorkflow === true ? t("workflow_step_disabled") : t("workflow_step_no_longer_applies")}
                          </Typography>
                        </div>
                      </Tooltip>
                      <Typography
                        variant="body2"
                        classes={{ body2: classes.typographyDisabledNoMargin }}
                      >
                        <b>{props.t("workflow_awaiting_review")}</b>
                      </Typography>
                    </div>
                  : 
                    <Typography
                      variant="body2"
                      classes={{ body2: classes.typographyDisabled }}
                    >
                      <b>{props.t("workflow_awaiting_review")}</b>
                    </Typography>
              )
            )}

          {(approvalStageEnabled && !autostartApproval &&
            awaitingApprovalStage !== null) &&
            getTimelineItem(
              classes.awaitingApprovalTimeline,
              waiting,
              awaitingApprovalStage !== null ? 
              <Box display="flex" alignItems="center">
                <ItemContentRevision
                  timeline
                  key={"awaitingapprovalstage"}
                  onItemClick={props.onRevisionClick}
                  data={awaitingApprovalStage}
                  onRevisionClick={props.onRevisionClick}
                  extendedSettings={JSON.stringify([
                    { label: "settings_content_revision_author", order: 0 },
                    {
                      label: "settings_content_revision_created_date",
                      order: 1,
                    },
                  ])}
                  secondarySetting={"author"}
                />
                {(awaitingApprovalStage && awaitingApprovalStage.reworks != null) &&
                  (awaitingApprovalStage.reworks.length > 0 && (
                    <Badge
                      color="secondary"
                      badgeContent={awaitingApprovalStage.reworks.length}
                    >
                      <FlagIcon />
                    </Badge>
                  ))}
              </Box>
              : <></>,
              awaitingApprovalStage && (
                <>
                  <Typography variant="body2" color="textSecondary">
                    {awaitingApprovalStage.reviewedBy !== null &&
                      awaitingApprovalStage.reviewedBy.length > 0
                      ? moment(
                        awaitingApprovalStage.reviewedBy[
                          awaitingApprovalStage.reviewedBy.length - 1
                        ].createdDate
                      ).fromNow()
                      : ""}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <b>{props.t("workflow_reviewed_awaiting_approval_stage")}</b>
                  </Typography>
                </>
              )
            )}
          {(approvalStageEnabled || awaitingApproval !== null) &&
            getTimelineItem(
              awaitingApproval !== null
                ? classes.awaitingApprovalTimeline
                : classes.emptyTimeline,
              approver,
              awaitingApproval !== null ? (
                <ItemContentRevision
                  timeline
                  key={"awaitingapproval"}
                  onItemClick={props.onRevisionClick}
                  data={awaitingApproval}
                  onRevisionClick={props.onRevisionClick}
                  extendedSettings={JSON.stringify([
                    { label: "settings_content_revision_author", order: 0 },
                    {
                      label: "settings_content_revision_created_date",
                      order: 1,
                    },
                  ])}
                  secondarySetting={"author"}
                />
              ) : (
                <></>
              ),
              awaitingApproval ? (
                <>
                  {workflowUsers.approvers === 0 && isSysAdmin && 
                    <div>
                      <Tooltip
                        title={getDisabledWorkflowTooltip("approve","Approver",approverTeams,approveInTaxWorkflow)}
                      >
                        <div className={classes.workflowWarning}>
                          <BlockIcon color="error" />
                          <Typography
                            variant="body2"
                            classes={{ body2: classes.workflowWarningTitle }}
                          >
                            {approveInTaxWorkflow === true ? t("workflow_step_disabled") : t("workflow_step_no_longer_applies")}
                          </Typography>
                        </div>
                      </Tooltip>
                    </div>
                  }
                  <Typography variant="body2" color="textSecondary">
                    {awaitingApproval.createdDate !== null
                      ? moment(awaitingApproval.createdDate).fromNow()
                      : ""}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <b>{props.t("workflow_awaiting_approval")}</b>
                  </Typography>
                </>
              ) : (
                workflowUsers.approvers === 0 && isSysAdmin 
                ? <div>
                  <Tooltip
                    title={getDisabledWorkflowTooltip("approve","Approver",approverTeams,approveInTaxWorkflow)}
                  >
                    <div className={classes.workflowWarning}>
                      <BlockIcon color="error" />
                      <Typography
                        variant="body2"
                        classes={{ body2: classes.workflowWarningTitle }}
                      >
                        {approveInTaxWorkflow === true ? t("workflow_step_disabled") : t("workflow_step_no_longer_applies")}
                      </Typography>
                    </div>
                  </Tooltip>
                  <Typography
                    variant="body2"
                    classes={{ body2: classes.typographyDisabledNoMargin }}
                  >
                    <b>{props.t("workflow_awaiting_approval")}</b>
                  </Typography>
                </div>
                : 
                <Typography
                  variant="body2"
                  classes={{ body2: classes.typographyDisabled }}
                >
                  <b>{props.t("workflow_awaiting_approval")}</b>
                </Typography>
              )
            )}
          {(publishStageEnabled || awaitingPublish !== null) &&
            getTimelineItem(
              awaitingPublish !== null
                ? classes.awaitingPublishTimeline
                : classes.emptyTimeline,
              published,
              awaitingPublish !== null ? (
                <ItemContentRevision
                  timeline
                  key={"awaitingpublish"}
                  onItemClick={props.onRevisionClick}
                  data={awaitingPublish}
                  onRevisionClick={props.onRevisionClick}
                  extendedSettings={JSON.stringify([
                    { label: "settings_content_revision_author", order: 0 },
                    {
                      label: "settings_content_revision_created_date",
                      order: 1,
                    },
                  ])}
                  secondarySetting={"author"}
                />
              ) : (
                <></>
              ),
              workflowActive === true && awaitingPublish ? (
                <>
                  {workflowUsers.publishers === 0 && isSysAdmin && 
                    <div>
                      <Tooltip
                        title={getDisabledWorkflowTooltip("publish","Publisher",publisherTeams,publishInTaxWorkflow)}
                      >
                        <div className={classes.workflowWarning}>
                          <BlockIcon color="error" />
                          <Typography
                            variant="body2"
                            classes={{ body2: classes.workflowWarningTitle }}
                          >
                            {publishInTaxWorkflow === true ? t("workflow_step_disabled") : t("workflow_step_no_longer_applies")}
                          </Typography>
                        </div>
                      </Tooltip>
                    </div>
                  }                
                  <Typography variant="body2" color="textSecondary">
                    {awaitingPublish.createdDate !== null
                      ? moment(awaitingPublish.createdDate).fromNow()
                      : ""}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <b>{props.t("workflow_awaiting_publish")}</b>
                  </Typography>
                </>
              ) : (
                  <Typography
                    variant="body2"
                    classes={{ body2: classes.typographyDisabled }}
                  >
                    <b>{props.t("workflow_awaiting_publish")}</b>
                  </Typography>
                // workflowUsers.publishers === 0 && isSysAdmin 
                // ? 
                //   <div>
                //     <Tooltip
                //       title={getDisabledWorkflowTooltip("publish","Publisher",publisherTeams,publishInTaxWorkflow)}
                //     >
                //       <div className={classes.workflowWarning}>
                //         <BlockIcon color="error" />
                //         <Typography
                //           variant="body2"
                //           classes={{ body2: classes.workflowWarningTitle }}
                //         >
                //           {publishInTaxWorkflow === true ? t("workflow_step_disabled") : t("workflow_step_no_longer_applies")}
                //         </Typography>
                //       </div>
                //     </Tooltip>
                //     <Typography
                //       variant="body2"
                //       classes={{ body2: classes.typographyDisabledNoMargin }}
                //     >
                //       <b>{props.t("workflow_awaiting_publish")}</b>
                //     </Typography>
                //   </div>
                // : 
                //   <Typography
                //     variant="body2"
                //     classes={{ body2: classes.typographyDisabled }}
                //   >
                //     <b>{props.t("workflow_awaiting_publish")}</b>
                //   </Typography>
              )
            )}

          {!revisionSummary.liveRevision &&
            getTimelineItem(
              classes.emptyTimeline,
              published,
              <KpsListItem hideExpand={true}>
                <ListItemText primary={props.t("no_live_revision")} secondary={""} />
              </KpsListItem>
            )}
          {revisionSummary.liveRevision && (
            <div className={classes.liveWrapper}>
              {getTimelineItem(
                classes.liveRevisionTimeline,
                published,
                <ItemContentRevision
                  timeline
                  key={"live"}
                  onItemClick={props.onRevisionClick}
                  data={revisionSummary.liveRevision}
                  onRevisionClick={props.onRevisionClick}
                  extendedSettings={JSON.stringify([
                    { label: "settings_content_revision_author", order: 0 },
                    {
                      label: "settings_content_revision_created_date",
                      order: 1,
                    },
                  ])}
                  secondarySetting={"author"}
                />,
                <>
                  <Typography variant="body2" color="textSecondary">
                    {revisionSummary.liveRevision.publishedBy !== null &&
                      revisionSummary.liveRevision.publishedBy.createdDate !== null
                      ? props.t("global_publish_past_tense") + " " +
                      moment(
                        revisionSummary.liveRevision.publishedBy.createdDate
                      ).fromNow()
                      : ""}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <b>{props.t("global_live")}</b>
                  </Typography>
                </>
              )}
            </div>
          )}
          {originalVersion && (
            <TimelineItem>
              <TimelineOppositeContent>
                <Typography variant="body2" color="textSecondary">
                  {originalVersion.createdDate !== null
                    ? moment(originalVersion.createdDate).fromNow()
                    : ""}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <b>{props.t("global_created")}</b>
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator
                classes={{ root: classes.timelineSeparator }}
              >
                <TimelineDot
                  color="primary"
                  classes={{ root: classes.startTimeline }}
                >
                  <PlayArrowIcon color="white" />
                </TimelineDot>
              </TimelineSeparator>
              <TimelineContent classes={{ root: classes.timeLineContent }}>
                <KpsListItem hideExpand={true}>
                  <ListItemText
                    disableTypography={true}
                    primary={""}
                    secondary={
                      !props.isMobile && (
                        <div
                          style={{
                            overflowWrap: "anywhere",
                            display: "flex",
                            flexDirection: "row",
                            marginLeft: theme.spacing(4),
                            alignItems: "center",
                          }}
                        >
                          <div style={{ fontWeight: "bold" }}>
                            {props.t("settings_content_revision_author")}
                          </div>
                          <div style={{ marginLeft: theme.spacing(2) }}>
                            <DisplayUser
                              userId={originalVersion.author.userId}
                              user={originalVersion.author}
                            />
                          </div>
                        </div>
                      )
                    }
                  />
                </KpsListItem>
              </TimelineContent>
            </TimelineItem>
          )}
        </Timeline>
      )}
    </>
  );

}

const mapStateToProps = (state) => ({
  isMobile: state.screen.isMobile,
  taxonomyTree: state.taxonomy.taxonomyTree,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(RevisionSummaryTimeline));
